import { useSummaryContext } from '../../../SummaryContext'
import { Typography } from 'antd'
import { InternalPayItemConnectionClassType } from 'shared'
import SubmittalTracker from '../../../../../../ConstructionAdminSubmittals/components/SubmittalTracker'
import DesignSubmittalLog from '../../../../../../DesignSubmittals/components/DesignSubmittalLog'
import FDCTracker from '../../../../../../FieldDesignChanges/components/FDCTracker'
import ConcreteTestSetTracker from '../../../../../../Concrete/components/ConcreteTestSetTracker'
import IssueTracker from '../../../../../../issues/Issues/IssueTracker'
import EJLog from '../../../../../../EngineeringJudgements/components/EJLog'

const InternalTable: React.FC = () => {
  const { globalId, selected } = useSummaryContext()
  if (!selected || selected.__typename !== 'ProjectToInternalConnection')
    return null
  const id = selected.internal.id
  if (id === InternalPayItemConnectionClassType.CAS.id)
    return <SubmittalTracker payItemGlobalId={globalId} />
  else if (id === InternalPayItemConnectionClassType.CTS.id)
    return <ConcreteTestSetTracker payItemGlobalId={globalId} />
  else if (id === InternalPayItemConnectionClassType.DS.id)
    return <DesignSubmittalLog payItemGlobalId={globalId} />
  else if (id === InternalPayItemConnectionClassType.FDC.id)
    return <FDCTracker payItemGlobalId={globalId} />
  else if (id === InternalPayItemConnectionClassType.Issue.id)
    return <IssueTracker payItemGlobalId={globalId} />
  else if (id === InternalPayItemConnectionClassType.EJ.id)
    return <EJLog payItemGlobalId={globalId} />
  else
    return (
      <Typography.Paragraph type="danger">
        Invalid Internal Type: {id}
      </Typography.Paragraph>
    )
}

export default InternalTable
